import styled from 'styled-components';
import CascadingElement from '../CascadingElement';

const GiftFlowButtonContainer = styled(CascadingElement)`
  margin-top: 20px;
  width: 100%;
`;

export default GiftFlowButtonContainer;
